export const levelColor = {
  INFO: '#1DB46C  ',
  WARNING: '#e69436',
  ERROR: '#b4433a',
  SUCCESS: '#00763D',
};
